import { AppHeaderContext } from '@deltek/specification-client/core/Contexts/AppHeaderContext'
import { makeStyles, Theme } from '@material-ui/core'
import React, { useContext, useEffect } from 'react'
import { BpmChartsContainer } from './components/BpmChartsContainer'

const title = 'Legacy Analytics'
const useStyles = makeStyles((theme: Theme) => ({
    chartArea: {
        width: 954,
        position: 'relative',
        left: theme.spacing(12),
        top: theme.spacing(2.4),
    },
}))

const AnalyticsPageContainer: React.FC = () => {
    const classes = useStyles()
    const { updateAppHeaderContent, updateAppHeaderStyles } = useContext(
        AppHeaderContext
    )

    useEffect(() => {
        updateAppHeaderContent(title, <></>)
        updateAppHeaderStyles?.({
            titleTextColor: '#04325B',
            backgroundColor: '#ffffff',
        })
    }, [updateAppHeaderContent, updateAppHeaderStyles])

    return (
        <div className={classes.chartArea}>
            <BpmChartsContainer data-testid="BpmChartsContainer" />
        </div>
    )
}
export default AnalyticsPageContainer
